import { Form, Modal } from "react-bootstrap";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import Select from "react-select";
import { Button, OutlineButton } from "../../components/layout/OutlineButton";
import { db } from "../../index";

export default function SelectContactsModal({
  show,
  setShow,
  estimate,
  invoice,
  submit,
  fetching,
}) {
  const { userInfos } = useContext(UserContext);
  const [contacts, setContacts] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [provider, setProvider] = useState(null);

  // Get provider from estimate or invoice
  useEffect(() => {
    const documentToUse = estimate || invoice;
    if (documentToUse?.customer?.id) {
      db.ref(`users/${userInfos.uid}/provider/${documentToUse.customer.id}`)
        .once("value", (snapshot) => {
          const providerData = snapshot.val();
          if (providerData) {
            setProvider({
              ...providerData,
              id: snapshot.key,
            });
          }
        });
    }
  }, [estimate, invoice, userInfos.uid]);

  // Map provider contacts to select options
  useEffect(() => {
    if (provider?.contacts?.length) {
      const contactOptions = provider.contacts.map((contact) => ({
        label: `[${contact.role}] ${contact.name} (${contact.phone}, ${contact.email})`,
        value: contact.email,
        data: contact,
      }));
      setContacts(contactOptions);
    } else {
      setContacts([]);
    }
  }, [provider]);

  // Handle contact selection change
  const handleContactsChange = useCallback((selectedOptions) => {
    setSelectedContacts(selectedOptions || []);
  }, []);

  return (
    <Modal show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Sélectionner les contacts</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="contacts">
            <Form.Label>Contacts supplémentaires</Form.Label>
            <Select
              isMulti
              options={contacts}
              value={selectedContacts}
              onChange={handleContactsChange}
              placeholder="Sélectionner les contacts..."
              noOptionsMessage={() => "Aucun contact disponible"}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <OutlineButton
          onClick={() => setShow(false)}
          disabled={fetching}
        >
          Annuler
        </OutlineButton>
        <Button
          onClick={() => {
            const selectedContactsData = selectedContacts.map(option => option.data);
            submit(selectedContactsData);
          }}
          disabled={fetching}
        >
          {fetching ? "Envoi en cours..." : "Envoyer"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}